import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {EntitlementDistributionSearchModel} from "../entitlement-distribution-search.model";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-entitlement-distribution-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(EntitlementDistributionSearchModel),
        registerSearchControl(EntitlementDistributionMultiSelectSearchControlComponent)
    ]
})
export class EntitlementDistributionMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<EntitlementDistributionSearchModel> {
    constructor(model: EntitlementDistributionSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }
}
